import React from 'react';
import { rendererIf } from 'constants/general';

interface RendererIfProps {
  condition: any;
  children: any;
  alternative?: any;
}

/**
 *
 * @param condition {Bollean} [Confidence to be fulfilled ]
 * @param component < Component /> [Component to be rendered if the cindion is met]
 * @param alternativeComponent < Component /> [Alternative component to render if condition is not met]
 */
const RendererIf: React.FC<RendererIfProps> = ({
  condition,
  children,
  alternative
}) => {
  return (
    rendererIf(condition, children, alternative)
  );
};

export default RendererIf;
